import { WESTREWARDS } from "./common";

// This creates a map of publication id's and what entitlements you need
// to view them.
export const PublicationToEntitlementMap = new Map<string, string[]>([
    // West Rewards Competitions
    ['entertainment/competitions/west-rewards', [WESTREWARDS]]
]);
